import { ExportDocuments } from '@dealstack/frontend/app/pages/Export/ExportDocuments/ExportDocuments';
import { memo } from 'react';

const ExportPage = () => {
	return (
		<div style={{ padding: '3rem' }}>
			<ExportDocuments />
		</div>
	);
};
export const Export = memo(ExportPage);
